import React, { createContext, useContext, useMemo } from 'react';

export type SlotRenderMode = 'inline' | 'canvas';

export interface SlotCanvasContextValue {
  mode: SlotRenderMode;
  /**
   * When true, newly registered slots should NOT auto-open the canvas
   * (e.g. while replaying chat history). Only meaningful in canvas mode.
   */
  suppressAutoOpen: boolean;
}

const DEFAULT_VALUE: SlotCanvasContextValue = {
  mode: 'inline',
  suppressAutoOpen: false,
};

const SlotCanvasContext = createContext<SlotCanvasContextValue>(DEFAULT_VALUE);

export interface SlotCanvasProviderProps {
  mode: SlotRenderMode;
  suppressAutoOpen?: boolean;
  children: React.ReactNode;
}

export function SlotCanvasProvider({
  mode,
  suppressAutoOpen = false,
  children,
}: SlotCanvasProviderProps) {
  const value = useMemo<SlotCanvasContextValue>(
    () => ({ mode, suppressAutoOpen }),
    [mode, suppressAutoOpen],
  );

  return (
    <SlotCanvasContext.Provider value={value}>
      {children}
    </SlotCanvasContext.Provider>
  );
}

export function useSlotCanvasContext(): SlotCanvasContextValue {
  return useContext(SlotCanvasContext);
}
